import { useNavigate } from 'react-router-dom';
import { formatWon } from '@/utils/format';
import type { CartController } from './useCart';

export default function CartSummary({ cart }: { cart: CartController }) {
  const navigate = useNavigate();
  const { selected, selectedItems, itemTotal, shippingFee } = cart;

  return (
    <>
      <h2 style={{ fontSize: 17, marginTop: 0 }}>결제 예정 금액</h2>
      <div className="summary-row">
        <span>선택 상품 ({selectedItems.length}건)</span>
        <span>{formatWon(itemTotal)}</span>
      </div>
      <div className="summary-row">
        <span>배송비</span>
        <span>{shippingFee === 0 ? '무료' : formatWon(shippingFee)}</span>
      </div>
      <div className="summary-row summary-row--total">
        <span>합계</span>
        <span>{formatWon(itemTotal + shippingFee)}</span>
      </div>
      <button
        type="button"
        className="btn btn--primary btn--lg btn--block"
        style={{ marginTop: 16 }}
        disabled={selectedItems.length === 0}
        onClick={() => navigate('/checkout', { state: { cartItemIds: selected } })}
      >
        주문하기
      </button>
    </>
  );
}
